import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SubmitListingForm from '../components/SubmitListingForm';

const SubmitPage = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="max-w-2xl mx-auto py-8"
    >
      <button
        onClick={() => navigate('/')}
        className="text-gray-400 hover:text-gray-300 transition-colors mb-8 inline-flex items-center gap-2"
      >
        ← Return to Trending Chess
      </button>

      <SubmitListingForm />
    </motion.div>
  );
};

export default SubmitPage;
